// Unpublished Work © 2021-2026 Deere & Company.

import {processEnvSvc} from './process-env-svc';

export const getServiceNowUrl = () => processEnvSvc('SERVICE_NOW');
export const getMarketingPreferencesURL = () => processEnvSvc('MARKETING_PREFERENCES_URL');
export const getDeleteBusinessContactUrl = () => processEnvSvc('DELETE_BUSINESS_CONTACT_SERVICE_NOW_URL');
export const getHelpdeskUrl = () => processEnvSvc('HELPDESK_URL');
export const getFeedbackServiceNowUrl = () => processEnvSvc('FEEDBACK_SERVICE_NOW_URL');
